<template>

    <div class="section" id="section-resultatsrecherche">

        <!-- <div class="section" id="section-actualites">
            <div class="section-content">
                <div v-if="!loaded" class="container_preload">
                    <div class="roulette"></div>
                    <div>actualités</div>
                </div>
                <div v-else-if="loaded">
                    <div class="section-content-banner">
                        <div>Actualités</div>
                        <div>outils</div>
                        <div class="closer" @click="closeFooter()">╳</div>
                    </div>
                    <div class="section-content-loaded">
                        <div v-html="contenu"></div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="section-content">
            <div class="section-content-banner">
                <div>R&Eacute;SULTAT(S)</div>
                <div id="expression">
                    <template v-if="'acteurs' in resultats">
                        <span id="expression-full">Pour le terme «&nbsp;{{ resultats.recherche }}&nbsp;»</span>
                    </template>
                    <template v-else>
                        <span id="expression-empty">Aucun résultat pour le terme «&nbsp;{{ resultats.recherche }}&nbsp;»</span>
                    </template>
                </div>
                <div class="closer fermer" @click="closeFooter()">╳</div>
            </div>
            <div class="section-content" id="section-content-results">
                <template v-if="'acteurs' in resultats">

                    <template v-if="resultats.mot_clef.length > 0">
                        <div>
                            <div class="result-title">Mot-clés</div>
                            <ul id="result-keyword-wrapper" class="result-wrapper">
                                <li class="result result-keyword" v-for="mot_clef in resultats.mot_clef" :key="mot_clef.mot_clef">
                                    <span>{{ mot_clef.mot_clef }}</span>
                                    <ul>
                                        <li class="result result-file" v-for="fiche in mot_clef.fiches" :key="fiche.slug" @click="closeFooter(), goToItem('mots_clefs',fiche)" title="ouvrir cette fiche (ferme ce volet)">
                                            <span>{{ fiche.titre }}</span>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </template>

                    <template v-if="resultats.acteurs.length > 0">
                        <div>
                            <div class="result-title">Acteurs</div>
                                <ul id="result-actor-wrapper" class="result-wrapper">
                                    <li class="result result-actor" v-for="acteur in resultats.acteurs">
                                        <span>{{ acteur.patronyme }}</span>
                                        <ul>
                                            <li class="result result-file" v-for="fiche in acteur.fiches" :key="fiche.slug" @click="closeFooter(), goToItem('acteurs',fiche)" title="ouvrir cette fiche (ferme ce volet)">
                                                <span>{{ fiche.titre }}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                    </template>

                    <template v-if="resultats.fiches.length > 0">
                        <div>
                            <div class="result-title">Fiches</div>
                            <ul id="result-keyword-wrapper" class="result-wrapper">
                                <li class="result result-file" v-for="fiche in resultats.fiches" :key="fiche.slug" @click="closeFooter(), goToItem('interventions',fiche)" title="ouvrir cette fiche (ferme ce volet)">
                                    <span>{{ fiche.titre }}</span>
                                </li>
                            </ul>
                        </div>
                    </template>

                </template>
                <template v-else>
                    <!-- <div id="search-msg">Aucun résultat pour la recherche « {{ resultats.recherche }} »</div> -->
                </template>
            </div>
        </div>
    </div>

    <!-- <div class="contenu_volet_bas resultats">
        <div class="mention_resultats">
            <template v-if="'acteurs' in resultats">
                <div class="titre_resultat">
                    Résultats pour la recherche « {{ resultats.recherche }} »
                </div>

                <template v-if="resultats.fiches.length > 0">
                    <div class="titre_resultat">
                        <span class="souligne">Fiches</span>
                        <div v-for="fiche in resultats.fiches" :key="fiche.slug" class="resultat" @click="$router.push(url_base+'interventions/'+fiche.slug)">
                            &bull; {{ fiche.titre }}
                        </div>
                    </div>
                </template>

                <template v-if="resultats.mot_clef.length > 0">
                    <div v-for="mot_clef in resultats.mot_clef" :key="mot_clef.mot_clef" class="titre_resultat">
                        <span class="souligne">Mot-clef : {{ mot_clef.mot_clef }}</span>
                        <div v-for="fiche in mot_clef.fiches" :key="fiche.slug" class="resultat" @click="$router.push(url_base+'mots_clefs/'+fiche.slug)">
                            &bull; {{ fiche.titre }}
                        </div>
                    </div>
                </template>

                <template v-if="resultats.acteurs.length > 0">
                    <div v-for="acteur in resultats.acteurs" :key="acteur.patronyme" class="titre_resultat">
                        <span class="souligne">Acteur : {{ acteur.patronyme }}</span>
                        <div v-for="fiche in acteur.fiches" :key="fiche.slug" class="resultat" @click="$router.push(url_base+'acteurs/'+fiche.slug)">
                            &bull; {{ fiche.titre }}
                        </div>
                    </div>
                </template>

            </template>
            <template v-else>
                <div class="titre_resultat">
                    Aucun résultat pour la recherche « {{ resultats.recherche }} »
                </div>
            </template>
        </div>
    </div> -->
</template>

<script>

import { url_base } from '../../variables.js'

export default {
    props: ['resultats'],
    data() {
        return {
            url_base:url_base
        }
    },

    watch: { 
        resultats: function(newVal, oldVal) { // watch it
            //console.log(this.resultats);
        }
    },
    methods: {
        closeFooter : function(){
            document.body.setAttribute("data-footer",false);
            document.body.setAttribute("data-mode","");
        },
        goToItem(item_type,fiche){
            //console.log(item_type);
            if(window.innerWidth > 750){
                this.$router.push(url_base+item_type+'/'+fiche.slug);
            }else{
                this.$router.push(url_base+'interventions/'+fiche.slug);
            }
        }
    }
};
</script>
<style>


#section-content-results{
    /*display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 39px;
    grid-row-gap: calc(var(--interlignage-courant));*/
    margin-left: calc(var(--title-width-margin) - var(--interlignage-courant)*0.5);
    /*margin-top: calc(39px * -1.2);*/
}
#section-content-results ul, #section-content-results li{
    /*list-style: none;*/
    display: block;
}
#section-content-results > div{
    margin-right: calc(var(--interlignage-courant));
}
#section-content-results{
    columns: 2;
    break-inside: avoid-column;
}
#section-content-results ul li ul li{
    margin-left: calc(var(--interlignage-courant));
}
#section-content-results ul li{
    /*background-color: rgba(255,0,0,0.25);*/
    width: auto;
    display: table;
}
.result-wrapper{
    /*padding-left: calc(var(--interlignage-courant));*/
    margin-top: calc(var(--interlignage-courant));
    padding-bottom: 10vh;

}
.result-keyword{
    margin-bottom: calc(var(--interlignage-courant));
}
.result-file{
    cursor: pointer;
}
.result-file:hover{
    text-decoration: underline;
}
.result-file:before{
    content: "• ";
}
#expression{
    display: block!important;
    margin-top: 9px;
}
#expression > span#expression-full{}
#expression > span#expression-empty{}
.result-keyword > span:before{
    content: "○ ";
}
.result-actor > span:before{
    content: "⟡ ";
}
.result-actor{
    margin-bottom: calc(var(--interlignage-courant));
}
#search-msg{
    margin-left: calc(var(--interlignage-courant) * -0.65);
    color: red;
}
.result-title{
    border-bottom: 2px dotted black;
    padding-bottom: var(--tbm);
}
/*.mention_resultats .titre_resultat {
    padding-bottom:1em;
}
.mention_resultats .resultat {
    display:block;
    cursor:pointer;
}
.mention_resultats .resultat:hover {
    text-decoration: underline;
}
.contenu_volet_bas p {
    margin-top:0;
}
.contenu_volet_bas {}*/

/*.mention_resultats .resultat:hover {
    text-decoration: underline;
}*/



</style>